import React from 'react'
import styled from 'styled-components';
import parse from 'html-react-parser';

function Tarjetas({ items, backgroundColor, color , grid}) {
    const listItems = items.map((item, index) =>
        <CardWrapper length={items.length} key={index}>
            <Card className='card-inner'>
                <Front>
                    <span>{item.titulo}</span>
                    <img src={item.url}></img>
                </Front>
                <Back color={color}>
                    <span>{parse(item.data)}</span>
                </Back>
            </Card>
        </CardWrapper>
    );
    return (
        <Wrapper backgroundColor={backgroundColor} grid={grid}>
            {listItems}
        </Wrapper>
    )
}


const Wrapper = styled.div`
    box-sizing:border-box;
    display: grid;
    grid-template-columns: ${props => props.grid ? props.grid : '1fr 1fr 1fr'};
    justify-content:center;
    grid-gap:32px;
    padding: 32px 48px;
    padding-bottom:64px;
    width:100%;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
    
`;

const CardWrapper = styled.div`
    background-color: transparent;
    width: 100%;
    height: 200px;
    perspective: 1000px;
    cursor: pointer;

    ${({length}) => length===4 &&`
     :nth-child(4){
        grid-column-start: 2;
    }
  `}

    &:hover .card-inner{
        transform: rotateY(180deg);
    }
`;

const Card = styled.div`
    box-sizing:border-box;
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
   
`;
const Front = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    background-color: var(--color-blanco);
    border-radius:10px;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    span{
        font-weight:700;
        margin-bottom:8px;
    }

    img{
        max-height:150px;
    }
`;

const Back = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    background-color: ${props => props.color ? props.color : 'var(--color-azul-oscuro)'};
    color: white;
    transform: rotateY(180deg);
    border-radius:10px;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    b{
        color:var(--color-azul-claro);
    }
    small{
      font-size:.6em;
    }
`;










export default Tarjetas

/*

  display :flex;
    flex-direction:column;
    align-items:center;
    padding: 16px;
    background-color: var(--color-blanco);
    border-radius:16px;
    box-shadow: drop-shadow(20px 20px 40px rgba(0, 0, 0, 0.1));
    perspective:1000px;
*/